export default __webpack_public_path__ + "static/media/2_long.2eec77f9.svg";